import React from 'react';

import Pic1 from '../../InstallImages/Modules/Hyundai395W';

const hyu395Link = <a href="https://www.dropbox.com/s/j9te77gk4nk5g2f/Hyundai%2C%20395W%2C%20Mono%2C%20Silver%20Frame%2C%20.pdf?dl=0" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const Module = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">
                Hyundai is one of the most recognizable names in the solar industry. The company started its solar business in 2005, and its solar panels are produced by a separate branch of the company that owns Hyundai Motors. Even though their panels are manufactured in South Korea, but their products are generally considered to be an great value homeowners and businesses a like looking for a low-cost solar installation.
            </p>
            <ul>
                <h2>10-Year Product Warranty</h2>
                <li className="specsText">On materials and workmanship</li>
                <h2>25-Year Performance Warranty</h2>
                <li className="specsText">Initial year: 97%</li>
                <li className="specsText">Linear warranty after second year: with 0.7% annual degradation 80% is guaranteed up to 25 years
                </li>
            </ul>
            <ul> <h1>Key Features</h1>
                <li className="specsText">Both LID (Light Induced Degradation) and PID (Potential Induced Degradation) are strictly eliminated to ensure higher actual yield during the module&#39;s lifetime.</li>
                <li className="specsText">PERL technology provides ultra-high efficiency with better performance in low irradiation. Maximizes installation capacity in limited space.</li>
                <li className="specsText">Tempered glass and reinforced frame design withstand rigorous weather conditions such as heavy snow and strong wind.</li>
                <li className="specsText">Global brand with powerful financial strength provides a reliable 25-year warranty.</li>
                <li className="specsText">Various tests under harsh environmental conditions such as ammonia and salt-mist passed.</li>
                <li className="specsText">Hyundai’s R&D center is an accredited test laboratory of both UL and VDE.</li>
                <li className="specsText">{hyu395Link}</li>
            </ul>
        </div>
    </div>
);

export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/hyu395s.js